<div>
  <h2>{{ title }}</h2>
  <form class="input-form" [formGroup]="form">
    <table class="mat-elevation-z8">
      <thead>
        <th class="input-column-text">Muskelgruppe</th>
        <th class="input-column">Links Winkel V1</th>
        <th class="input-column">Links Wert</th>
        <th class="input-column">Links Winkel V3</th>
        <th class="input-column">Rechts Winkel V1</th>
        <th class="input-column">Rechts Wert</th>
        <th class="input-column">Rechts Winkel V3</th>
      </thead>
      <tbody>
        @for (row of dataHtml; track row.name) {
          <tr>
            <td class="input-column-text">
              <input
                class="text"
                [tabIndex]="startTabIndex + $index"
                [formControlName]="row.controlLabelName"
                type="text"
                placeholder="" />
            </td>
            <td class="input-column">
              <input
                [tabIndex]="startTabIndex + $index"
                [formControlName]="row.controlLeftV1Name"
                type="number"
                (change)="onInputChange($event, row.controlLeftV1Name, row)"
                [min]="-180"
                [max]="180"
                placeholder="" />
            </td>
            <td class="input-column">
              <input
                [tabIndex]="startTabIndex + $index"
                [formControlName]="row.controlLeftName"
                type="number"
                (change)="onInputChange($event, row.controlLeftName, row)"
                [min]="row.min"
                [max]="row.max"
                placeholder="" />
            </td>
            <td class="input-column">
              <input
                [tabIndex]="startTabIndex + $index"
                [formControlName]="row.controlLeftV3Name"
                type="number"
                (change)="onInputChange($event, row.controlLeftV3Name, row)"
                [min]="-180"
                [max]="180"
                placeholder="" />
            </td>
            <td class="input-column">
              <input
                [tabIndex]="startTabIndex + $index"
                [formControlName]="row.controlRightV1Name"
                type="number"
                (change)="onInputChange($event, row.controlRightV1Name, row)"
                [min]="-180"
                [max]="180"
                placeholder="" />
            </td>
            <td class="input-column">
              <input
                [tabIndex]="startTabIndex + $index"
                [formControlName]="row.controlRightName"
                type="number"
                (change)="onInputChange($event, row.controlRightName, row)"
                [min]="row.min"
                [max]="row.max"
                placeholder="" />
            </td>
            <td class="input-column">
              <input
                [tabIndex]="startTabIndex + $index"
                [formControlName]="row.controlRightV3Name"
                type="number"
                (change)="onInputChange($event, row.controlRightV3Name, row)"
                [min]="-180"
                [max]="180"
                placeholder="" />
            </td>
          </tr>
        }
      </tbody>
    </table>
    <div class="buttons">
      <button mat-raised-button color="secondery" (click)="onAddMuskelgruppe()">Muskelgruppe hinzufügen</button>
    </div>

    <mat-form-field class="note">
      <mat-label>Zusätzliche Hinweise (optional)</mat-label>
      <textarea
        [tabIndex]="startTabIndex + dataHtml.length * 2 + 1"
        type="text"
        matInput
        formControlName="note"
        placeholder=""></textarea>
    </mat-form-field>
  </form>
</div>
